<template>
  <Article />
</template>

<script>
import Article from "./components/Article.vue"
export default {
	name: "App",
	components: {
		Article
	}
}
</script>

<style>
</style>